import { isMobile } from "react-device-detect";
import { Link } from "react-router-dom";

import { useContext, useEffect, useState } from "react";
import { FranchiseContext } from "./../../contexts/franchiseContext";

import "./toys-page.scss";

import CardToy from "../../components/card/card";
import api from "./../../services/api";
import { LoadingContext } from "../../contexts/loadingContext";
import Swal from "sweetalert2";
import { useNavigate } from "react-router-dom";

const Toast = Swal.mixin({
  toast: true,
  position: "top-end",
  showConfirmButton: false,
  timer: 3000,
  timerProgressBar: true,
  didOpen: (toast) => {
    toast.onmouseenter = Swal.stopTimer;
    toast.onmouseleave = Swal.resumeTimer;
  },
});

function ToysPage() {
  const [toys, setToys] = useState([]);
  const [orderBy, setOrderBy] = useState("name");
  const [order, setOrder] = useState("desc");
  const [searchFilter, setSearchFilter] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [ageRanges, setAgeRanges] = useState([]);
  const [stimulis, setStimulis] = useState([]);
  const [selectdStatus, setSelectedStatus] = useState(0);
  const [rentalStatuses, setRentalStatuses] = useState([]);

  const [selectedAgeRanges, setSelectedAgeRanges] = useState({});
  const [selectedStimulis, setSelectedStimulis] = useState({});

  const { franchise } = useContext(FranchiseContext);
  const { setIsLoadingGlobal } = useContext(LoadingContext);

  const navigate = useNavigate();

  const getFranchiseToys = (franchiseId, page = 1) => {
    setIsLoadingGlobal(true);
    api
      .get(`franchises/${franchiseId}/toys`, {
        params: {
          s: searchFilter,
          orderBy,
          order,
          ageRanges: Object.keys(selectedAgeRanges).join(","),
          stimulis: Object.keys(selectedStimulis).join(","),
          status: selectdStatus,
          page,
        },
      })
      .then((response) => {
        setToys(response.data.data);
        setTotalPages(response.data.last_page);
        setIsLoadingGlobal(false);
      })
      .catch((error) => {
        if (error.status === 500) {
          Toast.fire({
            icon: "error",
            title: "Por favor, selecione a franquia que deseja acessar!",
          });
          navigate("/");
        }
      });
  };

  const fetchAgeRanges = () => {
    api.get("toyageranges").then((response) => {
      setAgeRanges(response.data);
    });
  };

  const fetchStimulis = () => {
    api.get("stimulis").then((response) => {
      setStimulis(response.data.data);
    });
  };

  const fetchRentalStatuses = () => {
    api.get("rentals/statuses").then((response) => {
      setRentalStatuses(response.data);
    });
  };

  const removeFilters = () => {
    setSearchFilter("");
    setAgeRanges("");
    setStimulis("");
    getFranchiseToys(franchise.id);
  };

  const changePage = (page) => {
    if (page === currentPage) return;
    setCurrentPage(page);
    getFranchiseToys(franchise.id, page);
  };

  useEffect(() => {
    if (!franchise.id) return;
    getFranchiseToys(franchise.id);
  }, [franchise]);

  useEffect(() => {
    fetchAgeRanges();
    fetchStimulis();
    fetchRentalStatuses();
  }, []);

  useEffect(() => {
    getFranchiseToys(franchise.id);
  }, [selectdStatus, selectedAgeRanges, selectedStimulis, orderBy, order]);

  return (
    <div
      className={`container-fluid d-flex flex-column align-items-center pb-5 toys-page`}
    >
      <div
        className={`container d-flex justify-content-between w-100 title ${
          isMobile ? "mobile-title" : ""
        }`}
      >
        <div className="d-flex align-items-center text-center gap-3 text">
          <h1>Brinquedos</h1>
          <div className="diviser"></div>
          <h2>Encontre o brinquedo ideal para seu filho!</h2>
        </div>
        <div className="filter">
          <select
            className="form-select h-100 w-100 form-select-lg mb-5"
            aria-label="Default select example"
            onChange={(e) => {
              switch (parseInt(e.target.value)) {
                case 1:
                  setOrderBy("name");
                  setOrder("asc");
                  break;
                case 2:
                  setOrderBy("name");
                  setOrder("desc");
                  break;
                case 3:
                  setOrderBy("rental");
                  setOrder("asc");
                  break;
                case 4:
                  setOrderBy("rental");
                  setOrder("desc");
                  break;
                default:
                  break;
              }
            }}
          >
            <option value={1}>Ordem Alfabética (A-Z)</option>
            <option value={2}>Ordem Alfabética (Z-A)</option>
            <option value={4}>Maior Preço</option>
            <option value={3}>Menor Preço</option>
          </select>
        </div>
      </div>
      <div
        className={`container d-flex ${
          isMobile ? "flex-column mt-4" : "mt-5"
        } w-100 listing`}
      >
        <div className={`filters ${isMobile ? "w-100" : ""}`}>
          <div className="d-flex flex-column select-filters">
            <div className="search">
              <h4 className="mb-2">Pesquise pelo brinquedo</h4>
              <div className="w-100 search-input">
                <div className="input-group">
                  <input
                    type="text"
                    className="form-control"
                    placeholder="Faça sua busca aqui"
                    aria-label="Amount (to the nearest dollar)"
                    onChange={(e) => setSearchFilter(e.target.value)}
                  />
                  <button
                    type="button"
                    className="btn p-0 button-search"
                    onClick={() => getFranchiseToys(franchise.id)}
                  >
                    <i className="bi bi-search"></i>
                  </button>
                </div>
              </div>
            </div>
            <div
              className="availability"
              style={isMobile ? { display: "none" } : { display: "block" }}
            >
              <h4 className="mb-2">Disponibilidade</h4>
              <select
                className="form-select w-100"
                aria-label="Default select example"
                onChange={(e) => setSelectedStatus(e.target.value)}
              >
                <option value={0}>Todos os Brinquedos</option>
                {rentalStatuses.map((rentalStatus) => {
                  return (
                    <option key={rentalStatus.id} value={rentalStatus.id}>
                      {rentalStatus.name}
                    </option>
                  );
                })}
              </select>
            </div>
            <div
              className="age"
              style={isMobile ? { display: "none" } : { display: "block" }}
            >
              <h4 className="mb-2">Faixa etária</h4>
              {ageRanges.map((ageRange) => {
                return (
                  <div className="form-check" key={ageRange.id}>
                    <input
                      className="form-check-input"
                      type="checkbox"
                      defaultValue=""
                      id={ageRange.id}
                      onChange={(e) => {
                        const cloneSelectedAgeRanges = { ...selectedAgeRanges };
                        if (e.target.checked) {
                          cloneSelectedAgeRanges[ageRange.id] = undefined;
                        } else {
                          delete cloneSelectedAgeRanges[ageRange.id];
                        }
                        setSelectedAgeRanges(cloneSelectedAgeRanges);
                      }}
                    />
                    <label className="form-check-label" htmlFor={ageRange.id}>
                      {ageRange.label}
                    </label>
                  </div>
                );
              })}
            </div>
            <div
              className="incentive"
              style={isMobile ? { display: "none" } : { display: "block" }}
            >
              <h4 className="mb-2">Por estímulos</h4>
              {stimulis.map((stimuli) => {
                return (
                  <div className="form-check" key={stimuli.id}>
                    <input
                      className="form-check-input"
                      type="checkbox"
                      defaultValue=""
                      id={stimuli.id}
                      onChange={(e) => {
                        const cloneSelectedStimulis = { ...selectedStimulis };
                        if (e.target.checked) {
                          cloneSelectedStimulis[stimuli.id] = undefined;
                        } else {
                          delete cloneSelectedStimulis[stimuli.id];
                        }
                        setSelectedStimulis(cloneSelectedStimulis);
                      }}
                    />
                    <label className="form-check-label" htmlFor={stimuli.id}>
                      {stimuli.name}
                    </label>
                  </div>
                );
              })}
            </div>
          </div>
          <div
            className="w-100 text-end remove-filters"
            style={isMobile ? { display: "none" } : { display: "block" }}
          >
            <button type="button" className="btn p-0" onClick={removeFilters}>
              Remover filtros
            </button>
          </div>
        </div>
        <div className="cards">
          <div className={`card-group mb-5 ${isMobile ? "mobile-grid" : ""}`}>
            {toys.map((toy, index) => (
              <CardToy key={index} toyData={toy} />
            ))}
          </div>
          {toys.length > 0 && (
            <nav className="navigation" aria-label="Page navigation example">
              <ul className="pagination justify-content-center">
                {Array.from({ length: totalPages }, (_, i) => (
                  <li
                    key={i}
                    className={`rounded-circle page-item ${
                      currentPage === i + 1 ? "page-item--active" : ""
                    }`}
                    onClick={() => changePage(i + 1)}
                  >
                    <Link className="page-link" to="#">
                      {i + 1}
                    </Link>
                  </li>
                ))}
              </ul>
            </nav>
          )}
        </div>
      </div>
    </div>
  );
}

export default ToysPage;
